import { ITaskFilters } from "./task.reducer";
import { Task } from "./task.model";
import { AccountObjectQueryFactory } from "../account-object/account-object.query-factory";

export class TaskQueryFactory extends AccountObjectQueryFactory<Task, ITaskFilters> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task-query-factory.ts